import fetchFromApiServer from 'services/api';

export function fetchContacts(requestObject) {
  const url = `/contact-page/get-contacts`;
  return fetchFromApiServer('GET', url, requestObject);
}
